const PUBLIC_URL = 'https://js.streambird.io/sdk/dist/v1.0.20/streambird.js';

function getJSUrl() {
  try {
    if (process.env.STREAMBIRD_JS_SDK_URL) {
      return process.env.STREAMBIRD_JS_SDK_URL;
    }
    if (process.env.REACT_APP_STREAMBIRD_JS_SDK_URL) {
      return process.env.REACT_APP_STREAMBIRD_JS_SDK_URL;
    }
    if (process.env.NEXT_PUBLIC_STREAMBIRD_JS_SDK_URL) {
      return process.env.NEXT_PUBLIC_STREAMBIRD_JS_SDK_URL;
    }
    if (process.env.STORYBOOK_STREAMBIRD_JS_SDK_URL) {
      return process.env.STORYBOOK_STREAMBIRD_JS_SDK_URL;
    }
    return PUBLIC_URL;
  } catch (err) {
    return PUBLIC_URL;
  }
}

export const STREAMBIRD_JS_URL = getJSUrl();
